module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "main": ""
    }
  }, [_c('dsbn-header'), _vm._v(" "), _c('main-hero', [_c('aside', [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Book Now")])])]), _vm._v(" "), _c('adventure-content'), _vm._v(" "), _c('contact-form')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31672fba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AdventureCampus.vue
// module id = 376
// module chunks = 0